import { lazyLoad } from '../../index'

export default {
  path: 'cards',
  component: lazyLoad('Admin/Trello/Cards'),
}
